import * as Actions from "../constants/Actions";
import * as Screens from "../constants/Screens";

const initState = {
    answer:             null,
    category:           null,
    clues:              null,
    cluesExtra:         null,
    currentPlayer:      0,
    currentGuess:       null,
    ejected:            false,
    enableCountdown:    true,
    indexHowToPlay:     0,
    listMovies:         null,
    numCluesShown:      0,
    numPlayers:         0,
    photoData:          null,
    photoIndex:         0,
    players:            null,
    pointsPlayer:       null,
    roundEnd:           false,
    roundStart:         true,
    roundTracker:       null,
    screen:             Screens.TITLE,
    shareScreen:        false,
    showAnswers:        false,
    showCluesExtra:     false,
    showCountdown:      false,
    showHistory:        false,
    showHowToPlay:      false,
    showPhotoModal:     false,
    showPointsModal:    false,
    soundEffects:       true,
    subcategory:        null,
    swipeControls:      false
}

const rootReducer = (state = initState, action) => {
    // console.log(action);

    switch(action.type) {
        case Actions.ASSIGN_POINTS:
            return {
                ...state,
                answer:             null,
                clues:              null,
                cluesExtra:         null,
                currentGuess:       null,
                ejected:            false,
                numCluesShown:      0,
                players:            updateStatsSwipe(state),
                pointsPlayer:       null,
                roundStart:         true,
                roundTracker:       updateTracker(state),
                showPointsModal:    false
            };
        case Actions.CHANGE_SCREEN:
            if (action.screen == Screens.TITLE)
                return { ...state, screen: action.screen, players: null, currentPlayer: 0 };
            else
                return { ...state, screen: action.screen };
        case Actions.CONTINUE:
            if (state.swipeControls && !state.ejected)
                return {
                    ...state,
                    roundEnd:           false,
                    showPointsModal:    true
                };
            else
                return {
                    ...state,
                    answer:         null,
                    clues:          null,
                    cluesExtra:     null,
                    currentGuess:   null,
                    ejected:        false,
                    numCluesShown:  0,
                    roundEnd:       false,
                    roundStart:     true,
                    roundTracker:   updateTracker(state)
                };
        case Actions.EJECT:
            return {
                ...state,
                ejected:        true,
                roundEnd:       true
            };
        case Actions.ENABLE_COUNTDOWN:      return { ...state, enableCountdown: !state.enableCountdown };
        case Actions.HIDE_COUNTDOWN:        return { ...state, showCountdown:   false };
        case Actions.LOAD_MOVIES:           return { ...state, listMovies:      action.listMovies };
        case Actions.SELECT_PLAYER:
            if (state.swipeControls)
                return { ...state, pointsPlayer:    action.player };
            else
                return { ...state, currentPlayer:   action.player };
        case Actions.SET_ANSWER:
            return {
                ...state,
                answer:         action.answer,
                currentGuess:   null
            };
        case Actions.SET_CATEGORY:          return { ...state, category:        action.category };
        case Actions.SET_CLUES:             return { ...state, clues:           action.clues };
        case Actions.SET_CLUES_EXTRA:       return { ...state, cluesExtra:      action.clues };
        case Actions.SET_GUESS:             return { ...state, currentGuess:    action.guess };
        case Actions.SET_NUM_PLAYERS:
            //TODO: Temp until numeric input works on web
            if (action.screen != Screens.TITLE && ((state.numPlayers > 1 && action.numPlayers < 2) || action.numPlayers > 4))
                return { ...state };
                
            return {
                ...state,
                numPlayers:     action.numPlayers,
                players:        initPlayers(state, action.numPlayers),
                roundTracker:   []
            };
        case Actions.SET_PHOTO_INDEX:       return { ...state, photoIndex:      action.index };
        case Actions.SET_PLAYER_ICON:
            return { 
                ...state,
                players:        setPlayerIcon(state, action.icon),
                showPhotoModal: false
            };
        case Actions.SET_PLAYER_NAME:       return { ...state, players:         setPlayerName(state, action.index, action.name) };
        case Actions.SET_SHARE_SCREEN:
            if (!state.shareScreen)
                return {
                    ...state,
                    shareScreen: !state.shareScreen,
                    showAnswers: false
                };
            else
                return {
                    ...state,
                    shareScreen: !state.shareScreen
                };
        case Actions.SET_SHOW_ANSWERS:      return { ...state, showAnswers:     !state.showAnswers };
        case Actions.SET_SOUND_EFFECTS:     return { ...state, soundEffects:    !state.soundEffects };
        case Actions.SET_SUBCATEGORY:       return { ...state, subcategory:     action.subcategory };
        case Actions.SET_SWIPE_CONTROLS:    return { ...state, swipeControls:   !state.swipeControls };
        case Actions.SHOW_CLUES_EXTRA:      return { ...state, showCluesExtra:  !state.showCluesExtra };
        case Actions.SHOW_HISTORY:          return { ...state, showHistory:     !state.showHistory };
        case Actions.SHOW_HOW_TO_PLAY:
            return {
                ...state,
                indexHowToPlay: 0,
                showHowToPlay:  !state.showHowToPlay
            };
        case Actions.SHOW_NEXT_CLUE:        return { ...state, numCluesShown:   state.numCluesShown + 1 };
        case Actions.SHOW_PHOTO_MODAL:
            return { 
                ...state,
                photoData:      action.photoData,
                showPhotoModal: action.showPhotoModal
            };
        case Actions.START_ROUND:
            return {
                ...state,
                numCluesShown:  0,
                roundStart:     false,
                showCountdown:  true
            };
        case Actions.SUBMIT_GUESS:
            return {
                ...state,
                players:        updateStats(state, action.correct),
                roundEnd:       action.correct
            };
        case Actions.SWITCH_HOW_TO_PLAY:    return { ...state, indexHowToPlay: state.indexHowToPlay + action.value };
    }

    return state;
}

function initPlayers(state, numPlayers) {
    var players = [];
    if (state.players == null) {
        for (var i = 0; i < numPlayers; i++) {
            var player = {
                guesses:    0,
                icon:       null,
                name:       "Player " + (i + 1),
                numCorrect: 0,
                score:      0,
            };
            players = [...players, player];
        }
    }
    else if (numPlayers < state.numPlayers)
        players = state.players.slice(0, numPlayers);
    else {
        players = state.players.slice(0);
        while (players.length < numPlayers) {
            var player = {
                guesses:    0,
                icon:       null,
                name:       "Player " + (players.length + 1),
                numCorrect: 0,
                score:      0,
            };
            players = [...players, player];
        }
    }

    return players;
}

function setPlayerIcon(state, icon) {
    var players = state.players.map((player) => player);
    players[state.photoIndex].icon = icon;
    
    return players;
}

function setPlayerName(state, index, name) {
    var players = state.players.map((player) => player);
    players[index].name = name;

    return players;
}

function updateStats(state, isCorrect) {
    var players = state.players.map((player) => player);
    players[state.currentPlayer].guesses++;
    
    if (isCorrect && !state.swipeControls) {
        players[state.currentPlayer].numCorrect++;
        players[state.currentPlayer].score += state.clues.length + 1 - state.numCluesShown;
    }
    return players;
}

function updateStatsSwipe(state) {
    var players = state.players.map((player) => player);
    players[state.pointsPlayer].score += state.clues.length + 1 - state.numCluesShown;

    return players;
}

function updateTracker(state) {
    var index = state.swipeControls ? state.pointsPlayer : state.currentPlayer;

    var lastRound = {
        movie:  state.answer,
        winner: (state.ejected) ? null : state.players[index].name
    };
    return [...state.roundTracker, lastRound];
}

export default rootReducer;